import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgOverflow = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <circle cx={8.333} cy={4.333} r={1.333} fill={_.color} />
    <circle cx={8.333} cy={8.333} r={1.333} fill={_.color} />
    <circle cx={8.333} cy={12.333} r={1.333} fill={_.color} />
  </svg>
);
const ForwardRef = forwardRef(SvgOverflow);
export default ForwardRef;
